// libs/core/version/version.service.ts
import { Injectable } from '@angular/core';
import { Capacitor } from '@capacitor/core';
import { App } from '@capacitor/app';
import { VERSION_CONFIG } from './version.config';

@Injectable({
  providedIn: 'root'
})
export class VersionService {
  
  async getVersionInfo() {
    if (Capacitor.isNativePlatform()) {
      // app nativa (mòbil)
      try {
        const info = await App.getInfo();
        return {
          appVersion: info.version,
          platform: Capacitor.getPlatform(),
          isNative: true
        };
      } catch {
        return {
          appVersion: 'N/A',
          platform: Capacitor.getPlatform(),
          isNative: true
        };
      }
    } else {
      // Web
      return {
        appVersion: VERSION_CONFIG.appVersion,
        platform: 'web',
        isNative: false
      };
    }
  }
}